import { useEffect, useState } from 'react';

function MisLugaresPanel({
  monitorUserId,
  vehiculoSeleccionado,
  modoCrearGeocerca,
  setModoCrearGeocerca,
  geocercaTemporal,
  setGeocercaTemporal,
  setGeocercaSeleccionada
}) {
  const [lugares, setLugares] = useState([]);
  const [creandoLugar, setCreandoLugar] = useState(false);
  const [nombre, setNombre] = useState('');
  const [tipo, setTipo] = useState('home');
  const [avisarLlegada, setAvisarLlegada] = useState(true);
  const [avisarSalida, setAvisarSalida] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [eliminandoId, setEliminandoId] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const vehicleId =
    vehiculoSeleccionado?.maccezVehicleId ??
    vehiculoSeleccionado?.id;

  useEffect(() => {
    setLugares([]);
    setCreandoLugar(false);
    setError('');
    setNombre('');
    setGeocercaTemporal(null);
    setGeocercaSeleccionada(null);
    setModoCrearGeocerca(false);

    if (!vehicleId) return;

    const controller = new AbortController();

    async function cargarLugares() {
      setCargando(true);

      try {
        const token = localStorage.getItem('token');

        const response = await fetch(
          `/api/saved-places?vehicleId=${encodeURIComponent(vehicleId)}&monitorUserId=${encodeURIComponent(monitorUserId)}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            },
            signal: controller.signal
          }
        );

        const data = await response.json();

        if (!response.ok || !data.success) {
          throw new Error(
            data.message || 'No se pudieron cargar los lugares'
          );
        }

        setLugares(data.places || []);
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError(err.message);
        }
      } finally {
        if (!controller.signal.aborted) {
          setCargando(false);
        }
      }
    }

    cargarLugares();

    return () => controller.abort();
  }, [
    vehicleId,
    monitorUserId,
    setGeocercaTemporal,
    setGeocercaSeleccionada,
    setModoCrearGeocerca
  ]);

  function iniciarCreacion() {
    setNombre('');
    setTipo('home');
    setAvisarLlegada(true);
    setAvisarSalida(true);
    setError('');
    setGeocercaTemporal(null);
    setGeocercaSeleccionada(null);
   setCreandoLugar(true);
setModoCrearGeocerca(false);
  }

  function cancelarCreacion() {
    setGeocercaTemporal(null);
    setModoCrearGeocerca(false);
    setError('');
    setCreandoLugar(false);
  }

  async function guardarLugar() {
    const latitude = Number(geocercaTemporal?.latitude);
    const longitude = Number(geocercaTemporal?.longitude);

    if (
      !geocercaTemporal ||
      !Number.isFinite(latitude) ||
      !Number.isFinite(longitude)
    ) {
      setError('Toca el mapa para ubicar el lugar.');
      return;
    }

    if (!nombre.trim()) {
      setError('Escribe un nombre para el lugar.');
      return;
    }

    setGuardando(true);
    setError('');

    try {
      const token = localStorage.getItem('token');

      const response = await fetch('/api/saved-places', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'X-Monitor-User-Id': String(monitorUserId)
        },
        body: JSON.stringify({
          vehicleId,
          name: nombre.trim(),
          placeType: tipo,
          latitude,
          longitude,
          radiusMeters: Math.max(
            30,
            Math.round(Number(geocercaTemporal.radius) || 150)
          ),
          notifyArrival: avisarLlegada,
          notifyDeparture: avisarSalida
        })
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data.message || 'No se pudo guardar el lugar'
        );
      }

      const nuevoLugar = {
        id: data.id,
        vehicle_id: vehicleId,
        name: nombre.trim(),
        place_type: tipo,
        latitude,
        longitude,
        radius_meters: Math.max(
          30,
          Math.round(Number(geocercaTemporal.radius) || 150)
        ),
        notify_arrival: avisarLlegada ? 1 : 0,
        notify_departure: avisarSalida ? 1 : 0
      };

      setLugares((anteriores) => [
        nuevoLugar,
        ...anteriores
      ]);

     setGeocercaTemporal(null);
setModoCrearGeocerca(false);
setCreandoLugar(false);
setNombre('');
    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  }
async function eliminarLugar(lugar) {
  const confirmado = window.confirm(
    `¿Eliminar "${lugar.name}" de este vehículo?`
  );

  if (!confirmado) return;

  setEliminandoId(lugar.id);
  setError('');

  try {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `/api/saved-places/${lugar.id}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Monitor-User-Id': String(monitorUserId)
        }
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(
        data.message || 'No se pudo eliminar el lugar'
      );
    }

    setLugares((anteriores) =>
      anteriores.filter((item) => item.id !== lugar.id)
    );

    setGeocercaSeleccionada((actual) =>
      actual?.id === `lugar-${lugar.id}`
        ? null
        : actual
    );
  } catch (err) {
    setError(err.message);
  } finally {
    setEliminandoId(null);
  }
}
  if (!vehicleId) {
    return (
      <p style={styles.mensaje}>
        Selecciona un activo para configurar sus lugares.
      </p>
    );
  }

  return (
    <div style={styles.contenedor}>
      <div style={styles.encabezado}>
        <strong>
          Mis lugares · {vehiculoSeleccionado.name}
        </strong>
        <span>
          {lugares.length} guardados
        </span>
      </div>

   {!creandoLugar && (
        <button
          type="button"
          onClick={iniciarCreacion}
          style={styles.botonPrincipal}
        >
          + Agregar lugar
        </button>
      )}

     {creandoLugar && (
        <div style={styles.formulario}>
         <span style={styles.mensaje}>
  {modoCrearGeocerca
    ? 'Toca el lugar en el mapa y arrastra para ajustar el círculo.'
    : 'Mueve y acerca el mapa hasta encontrar el lugar.'}
</span>

<button
  type="button"
  onClick={() =>
    setModoCrearGeocerca((actual) => !actual)
  }
  style={styles.botonSecundario}
>
  {modoCrearGeocerca
    ? 'Mover mapa'
    : 'Marcar lugar en el mapa'}
</button>

          <select
            value={tipo}
            onChange={(event) => setTipo(event.target.value)}
            style={styles.campo}
          >
            <option value="home">Casa</option>
            <option value="office">Oficina</option>
            <option value="gym">Gimnasio</option>
            <option value="family">Casa de un familiar</option>
            <option value="custom">Otro lugar</option>
          </select>

          <input
            value={nombre}
            onChange={(event) => setNombre(event.target.value)}
            placeholder="Nombre: Casa, Oficina..."
            maxLength={80}
            style={styles.campo}
          />

          {geocercaTemporal && (
            <span style={styles.mensaje}>
              Radio: {Math.max(
                30,
                Math.round(
                  Number(geocercaTemporal.radius) || 150
                )
              )} m
            </span>
          )}

          <label style={styles.opcion}>
            <input
              type="checkbox"
              checked={avisarLlegada}
              onChange={(event) =>
                setAvisarLlegada(event.target.checked)
              }
            />
            Avisarme cuando llegue
          </label>

          <label style={styles.opcion}>
            <input
              type="checkbox"
              checked={avisarSalida}
              onChange={(event) =>
                setAvisarSalida(event.target.checked)
              }
            />
            Avisarme cuando salga
          </label>

          <button
            type="button"
            onClick={guardarLugar}
            disabled={guardando}
            style={styles.botonPrincipal}
          >
            {guardando ? 'Guardando...' : 'Guardar lugar'}
          </button>

          <button
            type="button"
            onClick={cancelarCreacion}
            style={styles.botonSecundario}
          >
            Cancelar
          </button>
        </div>
      )}

      {error && (
        <p role="alert" style={styles.error}>
          {error}
        </p>
      )}

      {cargando ? (
        <p style={styles.mensaje}>Cargando lugares...</p>
      ) : lugares.length === 0 ? (
        <p style={styles.mensaje}>
          Este activo todavía no tiene lugares guardados.
        </p>
      ) : (
      lugares.map((lugar) => (
  <div
    key={lugar.id}
    style={{
      display: 'flex',
      gap: '6px'
    }}
  >
    <button
      type="button"
      onClick={() => {
        setModoCrearGeocerca(false);
        setGeocercaTemporal(null);
        setGeocercaSeleccionada({
          id: `lugar-${lugar.id}`,
          latitude: Number(lugar.latitude),
          longitude: Number(lugar.longitude),
          radius: Number(lugar.radius_meters)
        });
      }}
      style={{
        ...styles.lugar,
        flex: 1,
        minWidth: 0
      }}
    >
      <strong>{lugar.name}</strong>
      <span>{lugar.radius_meters} m</span>
    </button>

    <button
      type="button"
      disabled={eliminandoId === lugar.id}
      onClick={() => eliminarLugar(lugar)}
      style={styles.botonEliminar}
      aria-label={`Eliminar ${lugar.name}`}
    >
      {eliminandoId === lugar.id ? '…' : 'Eliminar'}
    </button>
  </div>
))
      )}
    </div>
  );
}

const styles = {
  contenedor: {
    display: 'flex',
    flexDirection: 'column',
    gap: '9px'
  },
  encabezado: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    color: '#ffffff',
    fontSize: '12px'
  },
  formulario: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  campo: {
    width: '100%',
    height: '38px',
    boxSizing: 'border-box',
    borderRadius: '10px',
    border: '1px solid #60a5fa',
    background: '#0f172a',
    color: '#ffffff',
    padding: '0 10px'
  },
  opcion: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    color: '#ffffff',
    fontSize: '12px'
  },
  botonPrincipal: {
    minHeight: '38px',
    border: 0,
    borderRadius: '10px',
    background: '#3b82f6',
    color: '#ffffff',
    fontWeight: 800
  },
  botonSecundario: {
    minHeight: '34px',
    borderRadius: '10px',
    border: '1px solid #64748b',
    background: 'transparent',
    color: '#ffffff'
  },
  lugar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px',
    borderRadius: '10px',
    border: '1px solid rgba(96,165,250,0.35)',
    background: 'rgba(15,23,42,0.65)',
    color: '#ffffff',
    textAlign: 'left'
  },
  botonEliminar: {
  padding: '0 10px',
  borderRadius: '10px',
  border: '1px solid rgba(248,113,113,0.5)',
  background: 'rgba(127,29,29,0.6)',
  color: '#ffffff',
  fontSize: '11px',
  fontWeight: 800,
  cursor: 'pointer'
},
  mensaje: {
    margin: 0,
    color: '#cbd5e1',
    fontSize: '12px',
    lineHeight: 1.4
  },
  error: {
    margin: 0,
    color: '#fca5a5',
    fontSize: '12px'
  }
};

export default MisLugaresPanel;
